module.exports = __webpack_public_path__ + "static/media/css.ad5c052f.png";